import { create } from "zustand";

type SelectedTab = "DSD" | "XBRL";

type SelectedTabState = {
  selectedTab: SelectedTab;
  setSelectedTab: (tab: SelectedTab) => void;
};

export const useSelectedTab = create<SelectedTabState>((set) => ({
  selectedTab: "DSD",
  setSelectedTab: (tab) => set({ selectedTab: tab }),
}));
